import { Component, Input } from '@angular/core';
import { SnQuillViewComponent } from '@components/common/sn-quill-view/sn-quill-view';

@Component({
	selector: 'sn-quill-view-web',
	template: require('./sn-quill-view-web.html')
})
export class SnQuillWebViewComponent extends SnQuillViewComponent {
	@Input() content: string;

	// We need to ensure that each and every link that will be clicked, have to be opened in new tab
	// The main reason for this is old client portal that gets loaded during redirection in the same tab.
	openUrlInNewTab(event): void {
		const el = event.target;
		if (el.tagName === 'A' && el.target !== '_blank') {
			event.preventDefault();
			window.open(el.href);
		}
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./web/modern/components/common/sn-quill-view/sn-quill-view-web.ts